const PIXEL_IDS = ['26595614193444448', '2044761986391971']

export function initMetaPixel() {
  try {
    if (typeof window === 'undefined') return

    // Set up fbq stub only once
    if (!(window as any).fbq) {
      const n: any = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
      })
      if (!(window as any)._fbq) (window as any)._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const firstScript = document.getElementsByTagName('script')[0]
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript)
      } else {
        document.head.appendChild(script)
      }
    }

    // Init each pixel + fire PageView for each
    PIXEL_IDS.forEach((id) => {
      ;(window as any).fbq('init', id)

      // noscript fallback pixel per ID
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`
      document.body.appendChild(img)
    })
    ;(window as any).fbq('track', 'PageView')
  } catch (e) {
    console.warn('Meta Pixel failed to initialize:', e)
  }
}

export function trackEvent(event: string, data?: Record<string, any>) {
  try {
    if ((window as any).fbq) {
      ;(window as any).fbq('track', event, data)
    }
  } catch (e) {
    console.warn('Meta Pixel track failed:', e)
  }
}
